<template>
  <span
    v-if="logo"
    class="inline-flex h-[22px] shrink-0 items-center rounded-full bg-white/[0.07] px-2.5"
    :title="`Broadcast on ${logo.label}`"
  >
    <!-- One height for every network, which only works because each asset's
         viewBox is cropped to its own ink. The published brand SVGs are not:
         FOX's wordmark fills 42% of its 24x24 box and "prime video" 31%, so
         drawn as shipped they came out at half the height of Netflix's. -->
    <img :src="logo.src" :alt="logo.label" class="block h-3.5 w-auto max-w-[68px] object-contain" />
  </span>
  <span
    v-else
    class="inline-flex h-[22px] shrink-0 items-center rounded-full bg-white/[0.07] px-2.5 text-xs font-semibold uppercase tracking-wide text-slate-300"
  >
    {{ broadcast || `Wk ${week}` }}
  </span>
</template>

<script>
import { networkLogo } from "../utils/networkLogos.js";

// The corner chip on a game card. Shows the broadcaster's mark when we
// recognise the network, and falls back to the network's name -- or "Wk N"
// when ESPN hasn't published a broadcast yet -- when we don't. Both states
// wear the same chip at the same height, so the corner doesn't change shape
// depending on whether a broadcast is known.
export default {
  name: "NetworkBadge",
  props: {
    broadcast: { type: String, default: null },
    week: { type: [Number, String], default: null },
  },
  computed: {
    logo() {
      return networkLogo(this.broadcast);
    },
  },
};
</script>
